import { produce } from 'immer';
import _ from 'lodash';

import { RESET_STATE } from 'store/global/actions';

import { RATE_LOCK_TERMS_CRITERIA_ACTION_TYPE } from '../actions';

const getFormattedRule = ({
  criteriaName,
  lockTermCriteriaId,
  parentLockTermId,
  expression,
  ...rule
}) => ({
  ...rule,
  name: criteriaName,
  criteriaId: lockTermCriteriaId,
  parentCriteriaId: parentLockTermId,
  expression: expression.value,
  userFriendlyExpression: expression.userFriendly,
});

const initialState = {};

const rateLockTermsCriteriaReducer = (state = initialState, { type, payload, meta }) =>
  produce(state, draft => {
    switch (type) {
      case RATE_LOCK_TERMS_CRITERIA_ACTION_TYPE.GET_CRITERIA:
        return _.mapValues(payload || initialState, getFormattedRule);

      case RATE_LOCK_TERMS_CRITERIA_ACTION_TYPE.CREATE_CRITERIA:
      case RATE_LOCK_TERMS_CRITERIA_ACTION_TYPE.EDIT_CRITERIA:
        draft[payload.lockTermCriteriaId] = getFormattedRule(payload);
        break;

      case RATE_LOCK_TERMS_CRITERIA_ACTION_TYPE.DELETE_CRITERIA:
        delete draft[meta.lockTermCriteriaId];
        break;

      case RESET_STATE:
        return initialState;

      default:
        return state;
    }
  });

export default rateLockTermsCriteriaReducer;
